import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { getObservationStats } from "../observations/api"

const initialState = {
  observationStats: {},
}

/**
 * Thunk to perform async logic to fetch observations stats
 *
 * @type {AsyncThunk<*, {readonly filter?: *, readonly page?: *}, {}>}
 */
export const fetchObservationsStats = createAsyncThunk(
  "observations/stats/fetch",
  /**
   *
   * @param filter the filters to apply to the observations stats query
   * @returns {Promise<*>}
   */
  async ({ filter }) => {
    const response = await getObservationStats({
      filter,
    })
    return response
  }
)

/**
 * Dashboard reducer
 */
export const dashBoardSlice = createSlice({
  name: "dashboard",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchObservationsStats.pending, (state) => {
        state.observationStats._loadStatus = "loading"
      })
      .addCase(fetchObservationsStats.fulfilled, (state, action) => {
        state.observationStats._loadStatus = "idle"
        state.observationStats.data = action.payload.data
        state.observationStats.at = action.payload.at
      })
      .addCase(fetchObservationsStats.rejected, (state, action) => {
        state.observationStats._loadStatus = "rejected"
        state.observationStats._errorMessage = action?.error?.message
      })
  },
})

// Selector for all the pipeline names
export const selectObservationStats = (state) =>
  state.dashboard.observationStats

export default dashBoardSlice.reducer
